<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/planoManutencao">
        Cadastro/Plano Manutenção
      </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <sticky-add-button
        tooltip="Adicionar Serviço"
        @click="addServico"
      />

      <v-form ref="formServ" v-model="valid" lazy-validation>
        <v-card>
          <v-data-table
            class="servicos-table"
            :headers="headers"
            :items="servicosL"
            :items-per-page="-1"
            hide-default-footer
            dense
          >
            <template v-slot:item.compartimento="{ item }">
              <div
                v-if="!item.editingCompartimento"
                @click="item.editingCompartimento = true"
                style="cursor: pointer"
              >
                {{ item.compartimento || "Selecionar..." }}
              </div>
              <v-autocomplete
                v-else
                v-model="item.compartimentoSelected"
                :items="compartimentos"
                item-text="descricao"
                item-value="id"
                return-object
                autofocus
                @blur="item.editingCompartimento = false"
                @change="
                  (val) => {
                    changeCompartimento(item.index, val);
                    item.editingCompartimento = false;
                  }
                "
              >
              </v-autocomplete>
            </template>
            <template v-slot:item.produto="{ item }">
              <div
                v-if="!item.editingProduto"
                @click="item.editingProduto = true"
                style="cursor: pointer"
              >
                {{ item.produto || "Selecionar..." }}
              </div>
              <v-autocomplete
                v-else
                v-model="item.produtoSelected"
                :items="listaProdutos"
                item-text="descricao"
                item-value="id"
                return-object
                autofocus
                @blur="item.editingProduto = false"
                @change="
                  (val) => {
                    changeServico(item.index, val);
                    item.editingProduto = false;
                  }
                "
              >
              </v-autocomplete>
            </template>
            <template v-slot:item.quantidade="{ item }">
              <v-text-field
                v-model="item.quantidade"
                type="number"
                v-mask="['#####']"
              >
              </v-text-field>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    type="button"
                    @click="addPeriodo(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="green">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Adicionar periodicidade</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="error"
                    @click="removeServico(item.index)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-thick
                  </v-icon>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
            <template v-slot:item.index="{ item }">
              <div
                v-if="editingItemIndex !== item.index"
                class="item-index-cell"
                @click="startEditingIndex(item)"
                title="Clique para alterar a posição"
              >
                {{ item.index + 1 }}
              </div>
              <v-text-field
                v-else
                v-model.number="item.indexEdit"
                type="number"
                :min="1"
                :max="servicosL.length"
                dense
                hide-details
                single-line
                autofocus
                class="item-index-input"
                @keydown.enter.prevent="moveServico(item, item.indexEdit)"
                @keydown.esc.prevent="cancelEditingIndex(item)"
                @blur="moveServico(item, item.indexEdit)"
              />
            </template>
            <template v-slot:body.append>
              <tr>
                <td
                  :colspan="headers.length"
                  class="text-right font-weight-medium"
                >
                  Total de itens: {{ servicosL.length }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-speed-dial bottom right fixed>
            <template v-slot:activator>
              <v-btn v-model="fab" color="blue darken-2" dark fab :disabled="salvando">
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>done</v-icon>
              </v-btn>
            </template>
            <v-btn
              @click="enviar"
              type="button"
              color="success"
              class="mr-4"
              :disabled="salvando"
              :loading="salvando"
            >
              {{ salvando ? "Salvando..." : "Salvar" }}
            </v-btn>
            <v-btn to="/planoManutencao" type="button" color="error" class="mr-4" :disabled="salvando"
              >Voltar</v-btn
            >
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      v-model="showModal"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline">Adicionar Serviços</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form2" v-model="validFrm2" lazy-validation>
            <servico
              ref="servAdd"
              :servicosL="servicosL"
              :showModal="showModal"
            />
          </v-form>
        </v-card-text>
        <v-card-actions
          style="position: sticky; bottom: 0; background: white; z-index: 1"
        >
          <v-spacer></v-spacer>
          <v-btn type="button" color="error" class="mr-4" @click="showModal = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalPeriodicidade" max-width="50%">
      <v-card>
        <v-card-title class="headline">Adicionar Periodicidade</v-card-title>
        <v-card-text>
          <!-- passa a lista editável com .sync -->
          <periodo
            ref="periodoAdd"
            :periodoL.sync="editingPeriodoL"
            :showModal="showModalPeriodicidade"
          />
        </v-card-text>
        <v-card-actions
          style="position: sticky; bottom: 0; background: white; z-index: 1"
        >
          <v-spacer></v-spacer>
          <v-btn type="button" color="error" class="mr-4" @click="fecharModalGravando"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { enviarPlanoManutencaoAsync } from "../../../services/planoManutencaoService";
import TabNavegacao from "../../Tabs/TabCadastroPlanoManutencao";
import Servico from "./Servico";
import Periodo from "./Periodicidade";
import StickyAddButton from "../../Shared/StickyAddButton.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { reindexarItensPlanoManutencao } from "../../../utils/planoManutencaoItens";

export default {
  name: "criarPlanoManutencao",
  data: () => ({
    overlay: false,
    salvando: false,
    valid: true,
    servicosL: [],
    descricao: null,
    editingItemIndex: null,
    showModalPeriodicidade: false,
    selectedIndex: null, // índice/identificador do item clicado
    editingPeriodoL: [],
    showModal: false,
    periodos: [],
    active_tab: 1,
    headers: [
      { text: "Item", value: "index", sortable: false },
      { text: "Serviço", value: "descricao", sortable: false },
      { text: "Periodicidades", value: "periodosL", sortable: false },
      { text: "Compartimento", value: "compartimento", sortable: false },
      { text: "Produto", value: "produto", sortable: false },
      { text: "Quantidade", value: "quantidade", sortable: false, width: "5%" },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("planoManutencao", ["planosManutencao"]),
    ...mapGetters("produto", { listaProdutos: "produtosSomente" }),
    ...mapState("compartimento", ["compartimentos"]),
  },
  methods: {
    ...mapActions("servicoPlano", ["atualizarServicosPlano"]),
    ...mapActions("periodicidade", ["atualizarPeriodicidades"]),
    ...mapActions("planoManutencao", ["atualizarPlanosManutencao"]),
    async enviar() {
      if (this.salvando) {
        return;
      }

      if (this.servicosL == null || this.servicosL.length <= 0) {
        this.$store.dispatch("ui/showSnackbar", {
          text: "Adicione os serviços ao Plano!",
          color: "error",
          timeout: 3000,
        });
        return;
      }

      if (!this.$refs.form.validate() || !this.$refs.formServ.validate()) {
        return;
      }
      try {
        const descricao = this.descricao;
        const itens = reindexarItensPlanoManutencao(this.servicosL);
        this.servicosL = [...itens];
        const payloadItens = JSON.parse(JSON.stringify(itens));

        this.salvando = true;
        this.overlay = true;

        const resposta = await enviarPlanoManutencaoAsync(descricao, payloadItens);

        if (resposta?.status && resposta.status != 200)  {
          this.$alert(resposta.message || "", "Descupe, falha na operação!", "error");
        } else {
          await this.atualizarPlanosManutencao();
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          //this.$router.push("/planoManutencao");
        }
      } catch (error) {
        this.$alert(
          error?.message || "Não foi possível salvar o plano de manutenção.",
          "Descupe, falha na operação!",
          "error"
        );
      } finally {
        this.overlay = false;
        this.salvando = false;
      }
    },
    addServico: function () {
      this.showModal = true;
    },
    addPeriodo(item) {
      // guarde um identificador da linha (você já tem item.index no objeto)
      this.selectedIndex = item.index;

      // garanta array (se vier null) e faça uma cópia para edição
      const atual = Array.isArray(item.periodos) ? item.periodos : [];
      this.editingPeriodoL = JSON.parse(JSON.stringify(atual));

      this.showModalPeriodicidade = true;
    },
    fecharModalGravando() {
      if (this.selectedIndex == null) {
        this.showModalPeriodicidade = false;
        return;
      }

      // clone final e grava no item correto de forma reativa
      const clone = JSON.parse(JSON.stringify(this.editingPeriodoL));
      const rowIdx = this.servicosL.findIndex(
        (s) => s.index === this.selectedIndex
      );
      if (rowIdx !== -1) {
        this.$set(this.servicosL[rowIdx], "periodos", clone);
      }

      // limpar estado
      this.selectedIndex = null;
      this.editingPeriodoL = [];
      this.showModalPeriodicidade = false;
    },
    removeServico(index) {
      this.servicosL = this.servicosL.filter((sp) => sp.index != index);
      this.reindexServicos();
    },
    startEditingIndex(item) {
      this.editingItemIndex = item.index;
      this.$set(item, "indexEdit", item.index + 1);
    },
    cancelEditingIndex(item) {
      this.editingItemIndex = null;
      this.$delete(item, "indexEdit");
    },
    moveServico(item, novaPosicao) {
      if (this.editingItemIndex == null) return;

      const origem = this.servicosL.findIndex((sp) => sp.index === item.index);
      const destino = Number(novaPosicao) - 1;

      if (
        origem === -1 ||
        !Number.isInteger(destino) ||
        destino < 0 ||
        destino >= this.servicosL.length
      ) {
        this.cancelEditingIndex(item);
        return;
      }

      const lista = [...this.servicosL];
      const [servico] = lista.splice(origem, 1);
      lista.splice(destino, 0, servico);
      this.servicosL = lista;
      this.reindexServicos();
      this.cancelEditingIndex(servico);
    },
    reindexServicos() {
      this.servicosL = reindexarItensPlanoManutencao(this.servicosL);
    },
    async obterListas() {
      await this.atualizarServicosPlano();
      await this.atualizarPeriodicidades();
    },
    changeServico(index, produto) {
      const rowIdx = this.servicosL.findIndex((sp) => sp.index === index);
      if (rowIdx === -1) return;
      this.$set(this.servicosL[rowIdx], "idProduto", produto.id);
      this.$set(this.servicosL[rowIdx], "produto", produto.descricao);
    },
    changeCompartimento(index, compartimento) {
      const rowIdx = this.servicosL.findIndex((sp) => sp.index === index);
      if (rowIdx === -1) return;
      this.$set(this.servicosL[rowIdx], "idCompartimento", compartimento.id);
      this.$set(this.servicosL[rowIdx], "compartimento", compartimento.descricao);
    },
    computePeriodicidades(list) {
      return (Array.isArray(list) ? list : [])
        .map((p) => p?.quantidadeHoras)
        .filter((v) => v != null && v !== "")
        .join(", ");
    },
  },
  created: function () {
    this.obterListas();
  },

  watch: {
    editingPeriodoL: {
      deep: true,
      handler(val) {
        if (this.selectedIndex == null) return;
        const rowIdx = this.servicosL.findIndex(
          (s) => s.index === this.selectedIndex
        );
        if (rowIdx === -1) return;
        this.$set(
          this.servicosL[rowIdx],
          "periodosL",
          this.computePeriodicidades(val)
        );
      },
    },
  },
  components: {
    TabNavegacao,
    Servico,
    Periodo,
    StickyAddButton,
  },
};
</script>

<style scoped>
.servicos-table .v-data-table__wrapper {
  overflow-x: auto;
}

/* opcional: garante que a tabela tenha uma largura mínima e não "esmague" colunas */
.servicos-table table {
  min-width: 1100px;
}

.item-index-cell {
  cursor: pointer;
  min-width: 36px;
}

.item-index-input {
  max-width: 64px;
}
</style>
